import type { RefObject } from 'react';
import { ChatInferenceRequest } from '~/services/inference/chat';
import ChatActions from './chat-actions';
import ChatMessage from './chat-message';
import { ChatConversation } from '~/components/ui/Chat';

export default function ChatList(props: {
  messages: ChatInferenceRequest['messages'];
  isLoading: boolean;
  returnToolCallResponse: (response: string) => void;
  reload?: () => Promise<boolean>;
  stop?: () => Promise<void>;
  markdown?: boolean;
  children?: React.ReactNode;
  innerRef: RefObject<HTMLDivElement>;
}) {
  const messageLength = props.messages.length;
  const lastMessage = props.messages[messageLength - 1];

  const isLastMessageFromAssistant = messageLength > 0 && lastMessage?.role !== 'user';
  const showReload = props.reload && !props.isLoading && isLastMessageFromAssistant;
  const showStop = props.stop && props.isLoading;

  return (
    <>
      <ChatConversation innerRef={props.innerRef}>
        {props.messages.map((m, i) => (
          <ChatMessage
            key={m.id}
            message={m}
            nextMessage={props.messages[i + 1]}
            returnToolCallResponse={props.returnToolCallResponse}
            markdown={props.markdown}
          />
        ))}
        {props.children}
      </ChatConversation>
      <ChatActions reload={props.reload} stop={props.stop} showReload={showReload} showStop={showStop} />
    </>
  );
}
